import messages from './AdminListeUtilisateurs.json'
import swal from 'sweetalert2'
import ValueUtils from "../../../../../util/ValueUtils";

export default {
  name: "AdminListeUtilisateurs",
  i18n: messages,

  component: swal,

  data() {
    return {
      data: {
        utilisateurs: [],
        utilisateursFiltre: [],
        filtre: {},
        modification: false
      }
    }
  },

  mounted() {
    this.updateData();
  },

  methods: {
    /**
     *  Récupération des données
     */
    updateData() {
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios.get('rest/bd/utilisateur/liste').then(
        response => {
          this.updateDataSuccess(response.data)
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        },
        error => {
          this.updateDataFailed(error.response)
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        }
      )
    },

    /**
     * Fonction permettant la suppression (logique) de l'utilisateur
     */
    supprimer(idUser) {
      swal({
        title: this.$t('confirmation.suppression.titre'),
        text: this.$t('confirmation.suppression.texte'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: this.$t('confirmation.suppression.valider'),
        cancelButtonText: this.$t('confirmation.suppression.annuler'),
        buttonsStyling: false
      }).then((result) => {
        this.$eventHub.$emit(this.$eventHub.LOADING.START);
        this.$axios.delete('rest/bd/utilisateur/suppression/' + idUser).then(
          response => {
            this.$eventHub.$emit(this.$eventHub.SHOW_NOTIF, 'success', this.$t('notifications.success.title'), this.$t('notifications.success.message'))
            this.reset();

          },
          error => {
            this.$eventHub.$emit(this.$eventHub.SHOW_NOTIF, 'error', this.$t('notifications.error.title'), this.$t('notifications.error.message'))
            this.$eventHub.$emit(this.$eventHub.LOADING.END);
          }
        )
      })
    },

    /**
     * Fonction permettant d'enlever la suppression (logique) de l'utilisateur
     */
    retablir(idUser) {
      this.$eventHub.$emit(this.$eventHub.LOADING.START);
        this.$axios.delete('rest/bd/utilisateur/retablir/' + idUser).then(
          response => {
            this.$eventHub.$emit(this.$eventHub.SHOW_NOTIF, 'success', this.$t('notifications.success.title'), this.$t('notifications.success.message'))
            this.reset();

          },
          error => {
            this.$eventHub.$emit(this.$eventHub.SHOW_NOTIF, 'error', this.$t('notifications.error.title'), this.$t('notifications.error.message'))
            this.$eventHub.$emit(this.$eventHub.LOADING.END);
          }
        )
    },

    /**
     * Appelé lorsque la récupération des données s'est bien passée
     */
    updateDataSuccess(data) {
        this.data.utilisateurs = data;
        this.data.utilisateursFiltre = data;
        // Si on a au moins un utilisateur avec une "modification" à true
        this.data.utilisateurs.forEach(utilisateur => {
          if(ValueUtils.equals(utilisateur.modification,true)) {
            this.data.modification = true;
            return;
          }
        })
    },

    /**
     * Appelé lorsque la récupération des données s'est mal passée
     */
    updateDataFailed(error) {
      // On notifie l'erreur a l'utilisateur
      this.$notify.error({
        title: this.$t('notifications.error.title'),
        message: this.$t('notifications.error.message')
      })
    },

    /**
     * permet d'associer des couleurs aux lignes de la table
     * @param {*} param0
     */
    tableRowClassName({row, rowIndex}) {
      if (row.supprime === true) {
        return 'danger-row';
      } else if (this.$val.isEmpty(row.postesEnCours) && this.$val.isEmpty(row.postesFutur)) {
        return 'warning-row';
      }
      return '';
    },

    /**
     * Routage
     * @param {*} user
     */
    gotoUserDetail(user) {
      localStorage.setItem('selectedUser', JSON.stringify(user))
      this.$router.push({
        path: '/pages/admin/detail/user/' + user.id
      })
    },

    reset() {
      this.updateData()
    },

    /**
     * met un filtre sur la propriété "poste"
     * @param value : boolean
     */
    filtrePoste(value) {
      this.data.filtre.postesEnCours = value;
      this.refreshFiltre();
    },

    /**
     * met un filtre sur la propriété "actif"
     * @param value : boolean
     */
    filtreActif(value) {
      this.data.filtre.actif = value;
      this.refreshFiltre();
    },

    /**
     * met un filtre sur la propriété "supprime"
     * @param value : boolean
     */
    filtreSupprime(value) {
      this.data.filtre.supprime = value;
      this.refreshFiltre();
    },

    /**
     * actualise le tableau avec les filtres
     */
    refreshFiltre() {
      this.data.utilisateursFiltre = this.data.utilisateurs;
      Object.keys(this.data.filtre).forEach(key => {
        if(ValueUtils.isDefined(this.data.filtre[key])) {
          this.data.utilisateursFiltre = this.data.utilisateursFiltre.filter(utilisateur => {
            let value = utilisateur[key];
            if(Array.isArray(value)) {
              value = !ValueUtils.isEmpty(value);
            }
            return (ValueUtils.isDefined(utilisateur[key]) && value == this.data.filtre[key]);
          })
        }
      })
    }
}
}
